import { render, staticRenderFns } from "./ErpcDashCaseView.vue?vue&type=template&id=ba88f11a&scoped=true&"
import script from "./ErpcDashCaseView.vue?vue&type=script&lang=ts&"
export * from "./ErpcDashCaseView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba88f11a",
  null
  
)

export default component.exports